<template>
    <div class="flex z-1 border-bottom-2 border-surface-500 shadow-3">
        <div
            class="flex-shrink-0 bg-header-nav left-0 top-0 z-1 select-none transition-all transition-duration-150"
            style="width: 70px">
            <div class="flex flex-column">
                <div
                    class="flex flex-shrink-0 align-items-center justify-content-center bg-header-nav text-gray-50"
                    style="height: 60px">
                    <!-- Hamburger menu toggle button -->
                    <a
                        v-ripple
                        v-tooltip.right="{
                            value: !sidebarOpen ? 'Expand sidebar' : null,
                            showDelay: 300,
                        }"
                        @click="toggleSidebar"
                        class="flex-shrink-0 flex align-items-center justify-content-center cursor-pointer border-round text-bluegray-300 hover:text-bluegray-100 transition-duration-150 transition-colors p-ripple no-underline"
                        style="width: 32px; height: 32px">
                        <i class="far fa-bars" style="font-size: 1.125rem"></i>
                    </a>
                </div>
            </div>
        </div>

        <!-- Full logo - separate from sidebar section, always visible -->
        <div
            class="flex-shrink-0 bg-header-nav left-0 top-0 z-1 select-none transition-all transition-duration-150">
            <div class="flex flex-column">
                <div
                    class="flex flex-shrink-0 align-items-center bg-header-nav text-gray-50"
                    style="height: 60px; padding-left: 12px">
                    <!-- Logo - always full logo regardless of sidebar state -->
                    <img
                        :src="logoUrl"
                        alt="Corridor logo"
                        width="158"
                        height="30"
                        class="flex-shrink-0"
                        loading="eager"
                        decoding="async"
                        fetchpriority="high" />
                </div>
            </div>
        </div>

        <div class="flex flex-column flex-grow-1">
            <div
                class="flex align-items-center px-3 bg-header-bar shadow-2 static border-bottom-1 surface-border"
                style="height: 60px">
                <!-- Left side: Reserved for future use -->
                <div class="flex flex-row gap-2 align-items-center">
                    <!-- Venue selector moved to sidebar Navigation -->
                </div>

                <!-- Spacer to push incidents to the right -->
                <div class="flex-grow-1"></div>

                <!-- Right side: Incident navigation tabs (hidden in installer mode) -->
                <div
                    class="flex flex-row gap-2 mr-3"
                    v-if="
                        !isInstallerMode &&
                        incidentList?.data &&
                        incidentList.data.length > 0
                    ">
                    <div>
                        <ul
                            class="flex flex-row list-none p-0 m-0 gap-2 align-items-center select-none border-none surface-border right-0 top-100 z-1 shadow-none static">
                            <li>
                                <Button
                                    icon="fas fa-map"
                                    label="Home"
                                    @click="
                                        router.push({
                                            name: 'operator-home',
                                            params: { venueId: venueId },
                                        })
                                    "
                                    class="px-2 border-0"
                                    :class="[
                                        route.name == 'operator-home'
                                            ? 'text-white border-2 border-white'
                                            : '',
                                    ]" />
                            </li>

                            <li v-for="incident in incidentList.data">
                                <Button
                                    @click="
                                        router.push({
                                            name: 'operator-incident-dashboard',
                                            params: {
                                                venueId: venueId,
                                                incidentId: incident.id,
                                            },
                                        })
                                    "
                                    class="px-2 border-0 font-bold"
                                    :class="[
                                        'background-corridor-incident-' +
                                            incident.status,
                                        route.name ==
                                            'operator-incident-dashboard' &&
                                        route.params.incidentId == incident.id
                                            ? 'text-white border-2 border-white'
                                            : '',
                                    ]">
                                    <img
                                        :src="incidentIcons[incident.type]"
                                        class="mr-2"
                                        style="height: 20px; width: 20px" />
                                    {{ incident.title }}
                                </Button>
                            </li>
                        </ul>
                    </div>
                </div>

                <!-- Right side: Actions -->
                <ul
                    class="flex flex-row gap-3 list-none p-0 m-0 align-items-center select-none">
                    <li>
                        <RecordingIndicator />
                    </li>

                    <li>
                        <Button
                            icon="fasl fa-right-from-bracket"
                            text
                            :pt="{ root: { class: 'w-auto' } }"
                            @click="router.push({ name: 'signout' })" />
                    </li>
                </ul>
            </div>
        </div>
    </div>

</template>

<script setup>
import { defineAsyncComponent } from "vue";
import { useInterfaceProperties } from "@/composables/useInterfaceProperties.js";
import { useViewContextStore } from "@/stores/viewContext";
import { storeToRefs } from "pinia";

const mapContextStore = useViewContextStore();
const { venueId, isInstallerMode } = storeToRefs(mapContextStore);

const RecordingIndicator = defineAsyncComponent(
    () => import("./RecordingIndicator.vue"),
);

// Logo URL is resolved at build time with correct hashing
// Vite will inline the hashed asset path in production builds
import logoUrl from "@/assets/images/Logo_FullColor_OnDark.svg?url";

const { sidebarOpen, toggleSidebar } = useInterfaceProperties();

import { useGlobalProperties } from "@/composables/useGlobalProperties";
const { activeIncidentList: incidentList } = useGlobalProperties();

import { incidentIcons } from "@/helpers/IncidentIcons.js";

import { useRoute, useRouter } from "vue-router";
const router = useRouter();
const route = useRoute();
</script>
